<script setup>

</script>

<template>
  <div class="animate-pulse bg-gray-200 rounded w-full h-2"></div>
</template>
